export default __webpack_public_path__ + "static/type-right-gradient-1b6e52ebb4accf1b06de46e418586af8.svg";